import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { RxCross2 } from "react-icons/rx";
import axios from 'axios';
import Modal from './boughtBook/modal';
import { LoadingOverlay } from '../loading';
import books from '../../assets/img/books.png'

export const Alert = ({ shipment }) => {

  const [hidden, setHidden] = useState(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
      <div className={"innerContainer mx-auto alert text-white w-full shadow-md relative" + (hidden ? " hidden" : "") + (pathname.includes('/ordre/') || pathname.includes('/ordrer') || pathname.includes('/s%C3%A6lgbog') || pathname.includes('/bekr%C3%A6ftelse') || pathname.includes('/hj%C3%A6lp') ? " hidden" : "")}>
        <div className="absolute bg-gradient-to-r from-emerald-700 to-emerald-500 bg-size-200 bg-pos-0 h-full w-full opacity-90 z-10"></div>
        <div className="absolute right-5 md:right-10 text-xl cursor-pointer z-30 top-5" onClick={() => setHidden(true)}><RxCross2 /></div>
        <div className="mx-10 my-5 h-full flex flex-col gap-2 relative z-20">
          <div className="title text-lg font-semibold">
            <h2 className="">{(shipment.deliveryType === 3) ? `${shipment.products.length > 1 ? "Dine bøger" : "Din bog"} er blevet købt!` : `${shipment.products.length > 1 ? "Dine bøger" : "Din bog"} er klar til afsendelse!`}</h2>
          </div>
          <div className="title text-sm">
            <p className="">Tillykke! <span className="font-semibold">{shipment.buyer_first_name}</span> har købt <span className="font-semibold">{shipment.products.length}</span> af dine bøger. {shipment.deliveryType !== 3 ? `Afsend ${shipment.products.length > 1 ? "bøgerne" : "bogen"} indenfor 5 hverdage.` : `Køberen ønsker at afhente ${shipment.products.length > 1 ? "bøgerne" : "bogen"} på din adresse.`}</p>
          </div>
          <div className="help text-sm w-fit">
            {shipment.deliveryType !== 3 ? <p className="underline cursor-pointer" onClick={() => navigate(`/ordre?id=${shipment._id}`) & setHidden(true)}>Send pakken nu</p> : <p className="underline cursor-pointer" onClick={() => navigate(`/indbakke?id=${shipment._id}`) & setHidden(true)}>Kontakt køber</p>}
          </div>
        </div>
      </div>
  )
}

export const BookSold = ({ data }) => {

  const [hidden, setHidden] = useState(false)
  const navigate = useNavigate()

  return (
      <div className={"alert text-white w-full shadow-md relative overflow-hidden" + (hidden ? " hidden" : "")}>
        <div className="absolute bg-gradient-to-r from-emerald-700 to-emerald-400 bg-size-200 bg-pos-0 h-full w-full opacity-90 z-10"></div>
        <div className="absolute h-full hidden lg:flex items-center"><img src={books} className="lg:w-2/3 h-auto ml-auto lg:p-10 lg:mt-20" /></div>
        <div className="mx-10 my-5 h-full flex flex-col gap-6 relative z-20">
          <div className="flex flex-col gap-2">
            <div className="title text-base md:text-lg font-semibold">
              <h2 className="">{(data.deliveryType === 3) ? `${data.products.length > 1 ? "Dine bøger" : "Din bog"} er blevet købt!` : `${data.products.length > 1 ? "Dine bøger" : "Din bog"} er klar til afsendelse!`}</h2>
            </div>
            <div className="title text-sm md:text-base">
              <p className="">Tillykke! <span className="font-semibold">{data.products.length}</span> af dine bøger er blevet købt.</p>
              <p>{(data.deliveryType === 3) ? `Køberen ønsker at afhente ${data.products.length > 1 ? "bøgerne" : "bogen"} på din adresse. Aftal et passende afhentningstidspunkt med køber.` : `Herunder finder du alle detaljer, der er nødvendige for at afsende ${data.products.length > 1 ? "bøgerne" : "bogen"}.`}</p>
            </div>
            <div className="help text-sm w-fit">
              {(data.deliveryType === 3) ?
                <div className="text-nowrap mt-2 text-sm py-2 px-5 ring-1 ring-white text-center hover:ring-none hover:bg-white hover:text-black transition-[] cursor-pointer" onClick={() => navigate(`/indbakke?book=${data._id}`)}>Kontakt køber</div>
              :
                <p className="underline cursor-pointer" onClick={() => navigate('/hjælp/forsendelse?topic=0')}>Hvordan gør jeg?</p>}
            </div>
          </div>
        </div>
      </div>
  )
}

export const SuccesBuy = ({ data }) => {

  const [hidden, setHidden] = useState(false)
  const navigate = useNavigate()

  return (
      <div className={"alert text-white w-full shadow-md relative" + (hidden ? " hidden" : "")}>
        <div className="absolute bg-gradient-to-r from-emerald-700 to-emerald-500 bg-size-200 bg-pos-0 h-full w-full opacity-90 z-10"></div>
        <div className="mx-10 my-5 h-full flex flex-col gap-2 relative z-20">
          <div className="absolute right-0 text-xl cursor-pointer" onClick={() => setHidden(true)}><RxCross2 /></div>
          <div className="title text-lg font-semibold">
            <h2 className="">Tak for dit køb!</h2>
          </div>
          <div className="title text-sm">
            {data.deliveryType === 3 ? <p className="">Kontakt venligst sælger og aftal et afhentningstidspunkt</p> : <p className="">Fra dette øjeblik har sælgeren <span className="font-semibold">5 dage</span> til at afsende din bog. Vi holder dig opdateret på forsendelsesprocessen.</p>}
          </div>
        </div>
      </div>
  )
}

export const SuccessPayout = ({ amount }) => {

  const [hidden, setHidden] = useState(false)

  return (
      <div className={"alert text-white w-full shadow-md relative" + (hidden ? " hidden" : "")}>
        <div className="absolute bg-gradient-to-r from-emerald-700 to-emerald-400 bg-size-200 bg-pos-0 h-full w-full opacity-90 z-10"></div>
        <div className="mx-10 my-5 h-full flex flex-col gap-2 relative z-20">
          <div className="absolute right-0 text-xl cursor-pointer" onClick={() => setHidden(true)}><RxCross2 /></div>
          <div className="title text-lg font-semibold">
            <h2 className="">Din saldo er blevet udbetalt!</h2>
          </div>
          <div className="title text-sm">
            <p className="">Du har udbetalt <span className="font-semibold">{Number(amount/100).toFixed(2).toString().replace(/\./g, ',')} kr.</span> til din bankkonto. Der går <span className="underline">1 - 2 hverdage</span> før du modtager pengene.</p>
          </div>
        </div>
      </div>
  )
}


export const ConfirmOrRefund = ({ data, setReloadData, reloadData }) => {

  const [hidden, setHidden] = useState(false)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [openSatisfied, setOpenSatisfied] = useState(false)
  const [reason, setReason] = useState()
  const [loadRefund, setLoadRefund] = useState(false)
  const [requestSuccess, setRequestSuccess] = useState(false)
  const [loadSatisfied, setLoadSatisfied] = useState(false)
  const [satisfiedSuccess, setSatisfiedSuccess] = useState(false)
  const token = localStorage.getItem('token')
  
  const refundRequest = () => {
    if (typeof reason !== 'undefined') {
      setLoadRefund(true)
      axios({
          method: 'post',
          url: '/api/refundRequest',
          data: {
              'shipment': data._id,
              'reason': reason
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
      })
      .then(response => {
        setLoadRefund(false)
        setRequestSuccess(true)
        setReloadData(!reloadData)
      })
      .catch(error => {
        setLoadRefund(false)
        console.log(error);
      });
    }
  }
  
  const cancelRequest = () => {
    axios({
        method: 'post',
        url: '/api/cancelRequest',
        data: {
            'shipment': data._id,
            'reason': reason
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      setRequestSuccess(false)
      setReloadData(!reloadData)
    })
    .catch(error => {
      setLoadRefund(false)
      console.log(error);
    });
  }
  
  const satisfied = () => {
    setLoadSatisfied(true)
    axios({
        method: 'post',
        url: '/api/satisfied',
        data: {
            'shipment': data._id,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      setLoadSatisfied(false)
      setSatisfiedSuccess(true)
      setReloadData(!reloadData)
    })
    .catch(error => {
      setLoadSatisfied(false)
      console.log(error);
    });
  }

  return (
    <>
      <div className={"alert text-white w-full shadow-md relative overflow-hidden" + (hidden ? " hidden" : "")}>
        <div className="absolute bg-gradient-to-r from-emerald-700 to-emerald-400 bg-size-200 bg-pos-0 h-full w-full opacity-90 z-10"></div>
        <div className="absolute h-full hidden lg:flex items-center"><img src={books} className="lg:w-2/3 h-auto ml-auto lg:p-10 lg:mt-20" /></div>
        <div className="mx-10 my-5 h-full flex flex-col gap-6 relative z-20">
          {(data.status === 3) ?
            <div className="flex flex-col gap-2">
              <div className="title text-lg font-semibold">
                <h2 className="">Tak fordi du handlede hos os</h2>
              </div>
              <div className="title text-sm">
                <p className="">Din ordre er nu afsluttet. Rigtig god læselyst!</p>
              </div>
            </div>
          : (data.status === 5) ?
            <>
              <div className="flex flex-col gap-2">
                <div className="title text-lg font-semibold">
                  <h2 className="">Din anmodning om refundering behandles!</h2>
                </div>
                <div className="title text-sm">
                  <p className="">Vi har modtaget din anmodning om refundering af denne ordre.<br></br>Der kan gå op til 24 timer før din anmodning er færdigbehandlet.</p>
                </div>
              </div>
              <div className="buttons flex gap-x-5 gap-y-5 flex-wrap items-center text-white">
                <div className="w-fit">
                  <p className="text-sm font-medium cursor-pointer w-fit transition-[] hover:text-neutral-200 underline" onClick={cancelRequest}>Annuller anmodning</p>
                </div>
              </div>
            </>
          : (data.status === 0 && data.deliveryType === 3) || data.status === 2 ?
            <>
              <div className="flex flex-col gap-2">
                <div className="title text-lg font-semibold">
                  <h2 className="">{(data.status === 2) ? "Din bog er ankommet!" : "Din bog er klar til afhentning!"}</h2>
                </div>
                <div className="title text-sm">
                  <p className="">{(data.status === 2) ? "Din bog er blevet leveret. Afhent pakken og bekræft om alt er i orden." : "Kontakt venligst sælger og aftal et afhentningstidspunkt."}</p>
                </div>
              </div>
              <div className="buttons flex gap-x-5 gap-y-5 flex-wrap items-center text-white">
                <div className="text-nowrap text-sm py-2 px-5 ring-1 ring-white text-center hover:ring-none hover:bg-white hover:text-black transition-[] cursor-pointer" onClick={() => setOpenSatisfied(true)}>
                  Alt er i orden
                </div>
                <div className="w-fit">
                  <p className="text-sm font-medium cursor-pointer w-fit transition-[] hover:text-neutral-200 underline" onClick={() => setOpen(true)}>Anmod om refundering</p>
                </div>
              </div>
              <div className="text-sm">
                <p className="">Du har <span className="font-semibold">{data.timeToRefund} {(data.timeToRefund !== 1) ? "timer" : "time"} tilbage</span> til at reagere på eventuelle problemer med din ordre.</p>
              </div>
            </>
          :
            ""}
        </div>
      </div>
      <Modal width={"w-[80%] lg:w-1/3"} height={"auto"} open={open} onClose={() => setOpen(false)}>
        {(loadRefund) ?
          <LoadingOverlay />
        :
          ""
        }
        {(requestSuccess) ?
          <div className="flex flex-col h-full gap-10">
            <div className="title">
              <label for="select-reason" className="text-sm sm:text-base font-bold">Anmodning behandles</label>
            </div>
            <div className="form flex flex-col gap-5 text-sm">
              <p>Din anmodning er modtaget og behandles indenfor 24 timer.</p>
            </div>
            <div className="buttons flex flex-col gap-5">
              <button className="mx-auto py-2 text-sm sm:text-base" onClick={() => setOpen(false)}>Luk</button>
            </div>
          </div>
        :
          <div className="flex flex-col h-full gap-10">
            <div className="title">
              <label for="select-reason" className="text-sm sm:text-base font-bold">Vælg refunderingsårsag</label>
            </div>
            <div className="form flex flex-col gap-5 text-xs sm:text-sm">
              <select name="reason" id="select-reason" className="focus:outline-none" onChange={(e) => setReason(e.target.value)}>
                <option selected hidden className="border-none outline-none hover:bg-emerald-500">Vælg en årsag</option>
                <option value={1} className="border-none outline-none hover:bg-emerald-500">Pakken er gået tabt i forsendelsen</option>
                <option value={2} className="border-none outline-none hover:bg-emerald-500">Bogens tilstand er ikke som beskrevet</option>
              </select>
            </div>
            <div className="buttons flex flex-col gap-5">
              <button className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 transition-[] bg-size-200 bg-pos-0 hover:bg-pos-100 text-white mx-auto py-2 text-sm sm:text-base" onClick={() => refundRequest()}>Anmod</button>
              <button className="mx-auto py-2 text-sm sm:text-base" onClick={() => setOpen(false)}>Annuller</button>
            </div>
          </div>
        }
      </Modal>
      <Modal width={"w-[80%] lg:w-1/3"} height={"auto"} open={openSatisfied} onClose={() => setOpenSatisfied(false)}>
        {(loadSatisfied) ?
          <LoadingOverlay />
        :
          ""
        }
        {(satisfiedSuccess) ?
          <div className="flex flex-col h-full gap-10">
            <div className="title">
              <label for="select-reason" className="text-sm sm:text-base font-bold">Ordren er afsluttet</label>
            </div>
            <div className="form flex flex-col gap-5 text-sm">
              <p>Tak fordi du handlede hos os. Din ordre er nu afsluttet.</p>
            </div>
            <div className="buttons flex flex-col gap-5">
              <button className="mx-auto py-2 text-sm sm:text-base" onClick={() => setOpenSatisfied(false)}>Luk</button>
            </div>
          </div>
        :
          <div className="flex flex-col h-full gap-10">
            <div className="title text-center">
              <label for="select-reason" className="text-sm sm:text-base font-bold">Er du sikker?</label>
            </div>
            <div className="form flex flex-col gap-5 text-sm">
              <p>Når du bekræfter, at alt er i orden, afsluttes ordren og kan dermed ikke længere refunderes.</p>
            </div>
            <div className="buttons flex flex-col gap-5">
              <button className="w-full bg-gradient-to-r from-emerald-600 to-emerald-700 transition-[] bg-size-200 bg-pos-0 hover:bg-pos-100 text-white mx-auto py-2 text-sm sm:text-base" onClick={satisfied}>Bekræft</button>
              <button className="mx-auto py-2 text-sm sm:text-base" onClick={() => setOpenSatisfied(false)}>Annuller</button>
            </div>
          </div>
        }
      </Modal>
    </>
  )
}